export const generateLeadsCSVContent = (leads) => {
    const headers = [
      'lead_id', 'created_at', 'first_name', 'last_name', 'email', 'phone', 'date', 'hour', 'status', 'destination'
    ];
  
    const rows = leads.map(lead => [
      lead.id,
      lead.created_at,
      lead.first_name,
      lead.last_name,
      lead.email,
      lead.phone,
      lead.date || '',
      lead.hour || '',
      lead.status,
      lead.destination.name || ''
    ]);
  
    return [headers, ...rows].map(e => e.join(',')).join('\n');
  };
  
  export const exportLeadsToCSV = (leads) => {
    const csvContent = generateLeadsCSVContent(leads);
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'destination_leads.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };